import React from 'react';
import './IntuitButton.scss';
import connectShort from '../../../assets/intuit/C2QB_green_btn_short_default.svg';
import connectShortHover from '../../../assets/intuit/C2QB_green_btn_short_hover.svg';
import connectTall from '../../../assets/intuit/C2QB_green_btn_tall_default.svg';
import connectTallHover from '../../../assets/intuit/C2QB_green_btn_tall_hover.svg';
import signIn from '../../../assets/intuit/Sign_in_blue_btn_med_default.svg';
import signInHover from '../../../assets/intuit/Sign_in_blue_btn_med_hover.svg';

// Intuit's own button images, unchanged, as its App Store guidelines require.
const images = {
  'connect-short': { label: 'Connect to QuickBooks', image: connectShort, hover: connectShortHover },
  'connect-tall': { label: 'Connect to QuickBooks', image: connectTall, hover: connectTallHover },
  'sign-in': { label: 'Sign in with Intuit', image: signIn, hover: signInHover }
};

interface IntuitButtonProps {
  kind: keyof typeof images;
  onClick: () => void;
  disabled?: boolean;
  hidden?: boolean;
}

const IntuitButton: React.FC<IntuitButtonProps> = ({ kind, onClick, disabled, hidden }) => {
  const { label, image, hover } = images[kind];
  if (hidden) return null;
  return (
    <button type="button" className="intuit-button" aria-label={label} onClick={onClick} disabled={disabled}>
      <img className="intuit-button__default" src={image} alt="" />
      <img className="intuit-button__hover" src={hover} alt="" />
    </button>
  );
};

export default IntuitButton;
